function init() {
	const sliderBoxEls = document.querySelectorAll(".slider-box");
	const sliderEls = document.querySelectorAll(".slider");
	const sliderTextEls = document.querySelectorAll(".slider-wrap__number");
	let focusedEl = null;

	function removeClass(els) {
		els.forEach(el => {
			el.classList.remove("slider-box--active");
		})
	}

	sliderEls.forEach(el => {
		let sliderTextEl = el.nextElementSibling;

		el.addEventListener("input", function() {
			removeClass(sliderBoxEls);
			focusedEl = this.closest(".slider-box");
			if (focusedEl !== null) {
				focusedEl.classList.add("slider-box--active");
			}

			sliderTextEl.innerHTML = this.value;
		});
	});

	document.addEventListener("click", event => {
		if (focusedEl !== null && event.target.closest(".slider-box") !== focusedEl) {
			removeClass(sliderBoxEls);
		}
	});
}

export default {
	init,
}


